import React, { ReactNode } from 'react';

interface ModalProps {
    id?: string;
    title?: ReactNode;
    body: ReactNode;
    footer?: ReactNode;
    closeLabel?: string;
    modalBackground?: string;
    modalClassName?: string;
    isVisible?: boolean;
    onClose?: () => void;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const Modal: React.FC<ModalProps> = ({ id, title, body, footer, closeLabel = "Close", modalClassName, modalBackground, isVisible, onClose, onClick }) => {
    if (!isVisible) {
        return null; // Render nothing when not visible
    }

    return (
        <div
            className={`modal ${modalClassName} ${isVisible ? 'show' : ''}`} id={id}
            style={{
                display: 'block', // Always make the modal block when it's visible
                background: 'radial-gradient(50% 50% at 50% 50%, #000000 0%, rgba(0, 0, 0, 0.6) 100%)',
                animation: isVisible ? 'slideIn 0.9s ease-out' : '' // Apply sliding animation when visible
            }}
            onClick={onClick}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className={`modal-content ${modalBackground}`}>
                    {title &&
                        <div className="modal-header border-0 p-0">
                            <button type="button" className="btn-close btn-close-white me-1 mt-1" onClick={onClose}></button>
                        </div>
                    }
                    <div className="modal-title font-500-30 text-center" id={`${id}Label`}>{title}</div>
                    {body}
                </div>
            </div>
        </div>
    );
};

export default Modal;
